export default __webpack_public_path__ + "static/workplace-storage-55feed3a5238cbe4fa625318d29945df.jpg";